export class ClickNotifier {
    constructor(
        public handleClick: (clickedPoint: ClickDataPoint) => void
    ) { }
}

export class ClickDataPoint {
    constructor(
        public category: string,
        public serie: string,
        public y: any
    ) { }
}